<script setup>
import { ref, watch } from "vue";
import { Input } from "@/shared/ui/input";

const props = defineProps({
  label: { type: String, required: true },
  modelValue: { type: [String, Number, null], default: null },
  type: { type: String, default: "text" },
  full: { type: Boolean, default: false },
  required: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  placeholder: { type: String, default: "" },
});

const emit = defineEmits(["update:modelValue"]);

const local = ref(props.modelValue ?? "");

watch(
  () => props.modelValue,
  (v) => {
    local.value = v ?? "";
  }
);

function emitImmediate(v) {
  local.value = v ?? "";
  emit("update:modelValue", v === "" || v == null ? null : v);
}
</script>

<template>
  <div :class="['flex flex-col  min-w-0', full && 'col-span-full']">
    <span
      class="text-[12.5px] font-medium text-muted-foreground flex items-center gap-1"
    >
      {{ label }}
      <span v-if="required" class="text-destructive">*</span>
    </span>

    <Input
      :model-value="modelValue ?? ''"
      :type="type"
      :placeholder="placeholder"
      :disabled="disabled"
      size="sm"
      @input="(e) => emitImmediate(e.target.value)"
    />
  </div>
</template>
